import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const Layout = lazy(() => import('./layouts/layout'));
const InvoicesIndex = lazy(() => import('./pages/invoices'));

function App() {
  const basename = import.meta.env.BASE_URL === '/' ? undefined : import.meta.env.BASE_URL.replace(/\/$/, '');

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route path=':id' element={<InvoicesIndex />} />
          <Route index element={<InvoicesIndex />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
